export enum AdjustmentType {
  CASH_REWARD = 'Cash Reward',
  ORDER_TYPE = 'Order Type Adjustment',
}
